import { Box, Breadcrumbs, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CategoryTable from "./components/categoryTable";
import AddCategoryModal from "./components/AddCategoryModal";
import {
  Admin_Parivartan_Export_Category,
  Admin_Parivartan_Get_All_Categories,
} from "../../../constants";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { Download } from "lucide-react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

const CategoryComponent = ({}) => {
  const handleBack = () => {};
  const [addCategoryModalOpen, setAddCategoryModalOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCategoryData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${Admin_Parivartan_Get_All_Categories}`
      );
      const categories = response.data.categories || [];
      setCategoryList(categories); // keep your state update if needed
      return categories; // RETURN data for use in handleExport
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      return null; // Return null or empty array on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategoryData();
  }, []);

  const columns = [
    { headerName: "Category ID", field: "CategoryId" },
    { headerName: "Category Name", field: "CategoryName" },
    { headerName: "Created At", field: "CreatedAt" },
  ];

  const fetcCategoryData = async () => {
    try {
      const response = await axios.get(
        `${Admin_Parivartan_Get_All_Categories}`
      );
      const categories = response.data.categories || [];

      return categories; // RETURN data for use in handleExport
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      return null; // Return null or empty array on error
    }
  };

  const handleExport = async () => {
    const data = await fetcCategoryData();
    if (!data || data.length === 0) {
      console.warn("No data to export");
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = [
      columns.map((column) => column.headerName), // Header row
      ...data.map((row) =>
        columns.map((column) => {
          const value = row[column.field];
          if (["CreatedAt"].includes(column.field) && value) {
            return dayjs(value).format("DD-MM-YYYY"); // Format date
          }
          return value || "";
        })
      ),
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Category_Data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `category_data_${dayjs().format("YYYYMMDD")}.xlsx`);
  };

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key="1"
          color="inherit"
          to="/settings"
          onClick={handleBack}
        >
          Admin Panel
        </Link>
        <Typography key="2" color="text.primary">
          Category
        </Typography>
      </Breadcrumbs>

      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">Categories</h1>
          </div>
          <div>
            <Button
              onClick={() => setAddCategoryModalOpen(true)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              sx={{ mr: 1 }}
            >
              Add New Category
            </Button>

            <Button
              onClick={() => handleExport()}
              variant="contained"
              color="secondary"
              startIcon={<Download />}
              sx={{ mr: 1 }}
            >
              Download
            </Button>
          </div>
        </div>

        <CategoryTable
          categoryList={categoryList}
          loading={loading}
          setLoading={setLoading}
          onRefresh={getCategoryData}
        />

        <AddCategoryModal
          open={addCategoryModalOpen}
          onClose={() => setAddCategoryModalOpen(false)}
          onRefresh={getCategoryData}
        />
      </div>
    </>
  );
};

export default CategoryComponent;
